module.exports = __webpack_public_path__ + "static/media/bipedge-header copy.398bd3fe.png";